import { z } from 'zod';
/**
 * Source System Zod schemas for API validation
 *
 * Used by the source-system routes for request validation.
 */
export const saveScheduleRequestSchema = z.object({
    enabled: z.boolean(),
    scheduleCron: z.string().nullable(),
});
export const triggerSyncRequestSchema = z.object({
    syncScope: z.enum(['repos', 'commits', 'boards', 'pipelines']).optional(),
    forceFull: z.boolean().optional(),
});
export const saveReposConfigRequestSchema = z.object({
    repos: z.array(z.object({
        providerResourceId: z.string().min(1),
        providerResourceName: z.string().min(1),
        parentProviderResourceId: z.string().nullable().optional(),
        selectedBranch: z.string().min(1),
    })),
});
/** Schema for the unified settings save request (PUT /project/:uuid/systems/:type/settings) */
export const saveSourceSystemSettingsRequestSchema = z.object({
    repos: z
        .array(z.object({
        /**
         * UUID of the project_integration binding this repo row belongs to.
         * Required when submitting repo rows - each row must identify its integration binding
         * so the correct integration_resource and project_integration_resource rows are updated.
         */
        projectIntegrationUuid: z.string().min(1),
        providerResourceId: z.string().min(1),
        providerResourceName: z.string().optional(),
        parentProviderResourceId: z.string().nullable().optional(),
        selectedBranch: z.string().min(1),
        enabled: z.boolean().optional(),
    }))
        .optional(),
    pipelines: z
        .array(z.object({
        projectIntegrationUuid: z.string().min(1),
        providerResourceId: z.string().min(1),
        providerResourceName: z.string().optional(),
        pipelineCategory: z.enum(['build', 'release']),
        enabled: z.boolean().optional(),
    }))
        .optional(),
    schedule: z
        .object({
        enabled: z.boolean(),
        scheduleCron: z.string().nullable(),
    })
        .optional(),
});
export const repoBrowserFileQuerySchema = z.object({
    nodeId: z.string().min(1),
});
//# sourceMappingURL=source-system.js.map